/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Group_A_FallbackInputs */



/**
* | output |
* | --- |
* | "Group A" |
*
* @param {Compare_Event_Groups_Group_A_FallbackInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_group_a_fallback = /** @type {((inputs?: Compare_Event_Groups_Group_A_FallbackInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Group_A_FallbackInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Groupe A")
	if (locale === "de") return /** @type {LocalizedString} */ ("Gruppe A")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gruppo A")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Группа А")
	if (locale === "es") return /** @type {LocalizedString} */ ("Grupo A")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("A组")
	if (locale === "ja") return /** @type {LocalizedString} */ ("グループA")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समूह ए")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Grupo A")
	return /** @type {LocalizedString} */ ("Group A")
});